module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/adminextraescolares/adminextraescolares.component.scss
// module id = ./src/app/adminextraescolares/adminextraescolares.component.scss
// module chunks = main